import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    downloaded: string;
    uploaded: string;
    transcoding: string;
    loadingAriaLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Status label when download is complete */
            downloaded: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CompletedJobStatus.downloaded?c=6bh09trmjs1p", defaultMessage: "Downloaded" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status label when upload is complete */
            uploaded: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CompletedJobStatus.uploaded?c=1os5hmwiups3e", defaultMessage: "Uploaded" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Status label when transcoding is in progress */
            transcoding: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CompletedJobStatus.transcoding?c=278s13qk3d1l2", defaultMessage: "Preparing\u2026" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Aria label for loading spinner */
            loadingAriaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "CompletedJobStatus.loadingAriaLabel?c=57512ik3sq66", defaultMessage: "Loading" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
